import { useQuery } from "@tanstack/react-query";
import type { MaintenanceVehicleGroupListDto } from "@bi/types";
import { api } from "../../lib/api";

/** Filtro "grupo de veículos" das telas de acompanhamento (painel, O.S., plano). */
export function GroupSelect({ value, onChange, withNone = false, className = "w-56" }: {
  value: string;
  onChange: (groupId: string) => void;
  /** oferece "Sem grupo" (só onde a API entende `none`) */
  withNone?: boolean;
  className?: string;
}) {
  const grupos = useQuery({
    queryKey: ["maintenance", "vehicle-groups"],
    queryFn: () => api.get<MaintenanceVehicleGroupListDto>("/maintenance/vehicle-groups"),
    staleTime: 60_000,
  });
  const ativos = (grupos.data?.groups ?? []).filter((g) => g.active);
  if (!ativos.length && !value) return null;
  return (
    <select className={`input ${className}`} value={value} onChange={(e) => onChange(e.target.value)} aria-label="Grupo de veículos">
      <option value="">Toda a frota</option>
      {withNone && <option value="none">Sem grupo</option>}
      {ativos.map((g) => <option key={g.id} value={g.id}>{g.name} ({g.vehicleCount ?? 0})</option>)}
    </select>
  );
}
